import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`我們將帶來一系列與 DDD 或是開發流程相關的工作坊，目前已包含 Event Storming、Example Mapping、Aggregate Canvas、BDD、程式建模等等。`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      